import { ReactComponent as homeIcon } from "../../../assets/icons/home-icon.svg";
import { ReactComponent as homeIconHover } from "../../../assets/icons/home-icon-hover.svg";
import { ReactComponent as reportsIcon } from "../../../assets/icons/reports-icon.svg";
import { ReactComponent as reportsIconHover } from "../../../assets/icons/reports-icon-hover.svg";
import { ReactComponent as segmentIcon } from "../../../assets/icons/segment-icon.svg";
import { ReactComponent as segmentIconHover } from "../../../assets/icons/segment-icon-hover.svg";
import { ReactComponent as campaignsIcon } from "../../../assets/icons/campaigns-icon.svg";
import { ReactComponent as campaignsIconHover } from "../../../assets/icons/campaigns-icon-hover.svg";
import { ReactComponent as destinationsIcon } from '../../../assets/icons/destinations-icon.svg';
import { ReactComponent as destinationsIconHover } from '../../../assets/icons/destinations-icon-hover.svg';

import { NavItemType } from "./LeftNavigation";

export const NAVIGATION: NavItemType[] = [
  {
    segment: "",
    title: "Home",
    normal: homeIcon,
    hover: homeIconHover,
    adminOnly: false,
  },
  {
    segment: 'reports',
    title: 'Reports',
    normal: reportsIcon,
    hover: reportsIconHover,
    adminOnly: false,
  },
  {
    segment: "segments",
    title: "Segments",
    normal: segmentIcon,
    hover: segmentIconHover,
    adminOnly: false,
  },
  {
    segment: "campaigns",
    title: "Campaigns",
    normal: campaignsIcon,
    hover: campaignsIconHover,
    adminOnly: false,
  },
  { segment: 'destinations',
    title: 'Destinations',
    normal: destinationsIcon,
    hover: destinationsIconHover,
    adminOnly: true,
  }
];
